import { useState, useEffect } from 'react';

import * as usersService from '@frolight/services/api/usersService';
import useLocalizationUtils from '@frolight/hooks/useLocalizationUtils';

const useUnverifiedUserData = (verificationToken) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);
  const { changeLocale } = useLocalizationUtils()

  useEffect(() => {
    let mounted = true;
    
    const abortController = new AbortController();

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const getUnverifiedUserResult = await usersService.getUnverifiedUserByVerificationToken(
          abortController, { verificationToken }
        );
        if (mounted) setData(getUnverifiedUserResult.data);
        changeLocale(getUnverifiedUserResult.data.locale);
      } catch (err) {
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (verificationToken) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortController.abort();
    }

  }, [ verificationToken ]);

  return { loading, error, data };
};

export default useUnverifiedUserData;
